import React from 'react';
import { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'app/shared/link/link';

export const ShopBreadcrumbCustom = ({ name, id, typeId, setting, onLink }) => {
    const [hover, setHover] = useState(false);
    return (
        <Link
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            style={{
                color: `${
                    id === Number(typeId) && hover
                        ? setting.content.breadcrumbs.modal.activeHoverColor
                        : id === Number(typeId)
                        ? setting.content.breadcrumbs.modal.activeColor
                        : hover
                        ? setting.content.breadcrumbs.modal.commonHoverColor
                        : setting.content.breadcrumbs.modal.commonColor
                }`,
                background: hover
                    ? setting.content.breadcrumbs.modal.backgroundHover
                    : setting.content.breadcrumbs.modal.background,
            }}
            onClick={onLink}
            className={classNames('shop-breadcrumb', {
                'shop-breadcrumb_active': id === Number(typeId),
            })}
            to={`/categories/${id}`}
        >
            {name}
        </Link>
    );
};
